/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { PartnerConnectionDto } from './partnerConnectionDto';
import { MetaDataDto } from './metaDataDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface ExaAdapterV2Dto {
  activePartnerConnections?: Array<PartnerConnectionDto>;
  firmwareVersion?: string;
  id?: number;
  imsi?: string;
  lastHeartbeat?: string;
  mac?: string;
  metaData?: MetaDataDto;
  oem?: string;
  onlyGPS?: boolean;
  owner?: EnterpriseIdDto;
  pairedMachine?: MachineIdDto;
  retailer?: EnterpriseIdDto;
  serial?: string;
  type?: string;
  updateTime?: string;
}
